import styled from 'styled-components';
import {
  greenSp,
  graySphera,
  whiteSphera,
  grayPlaceholder,
  grayLightSphera,
  brandBlack
} from 'src/utilities/UIStyles/variables/Colors';
import { fadeIn, fadeOut } from 'src/utilities/animations';

export const ModalRegisterCLABE = styled.section`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  visibility: ${(props) => (props.showModalRegisterCLABE ? 'visible' : 'hidden')};
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-color: rgb(0, 0, 0, 0.5);
  z-index: 100;
  animation: ${(props) => (props.showModalRegisterCLABE ? fadeIn : fadeOut)} 0.5s linear;
  transition: all 0.5s;
  > div {
    width: 50%;
    background-color: ${whiteSphera};
    border-radius: 5px;
    padding-top: 1%;
    padding-bottom: 2.5%;

    > div {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      width: 100%;
      padding-bottom: 1.5%;
      > button {
        color: ${whiteSphera};
        font-weight: bold;
        font-size: 1.2vw;
        text-align: center;
        width: 30%;
        height: 40px;
        border: none;
        border-radius: 5px;
        background-color: ${greenSp};
        cursor: pointer;
      }
      > h3 {
        font-size: 1.5vw;
        color: ${graySphera};
        width: 90%;
        padding-left: 5%;
      }
      > figure {
        width: 25px;
        height: 25px;
        cursor: pointer;
        > img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div {
      width: 50%;
    }
  }

  @media (max-width: 600px) {
    > div {
      width: 90%;
      padding-top: 5%;
      padding-bottom: 5%;
      > div:nth-child(1) {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        padding-bottom: 5%;
        border-bottom: 1px solid #b7bcc7;
        > h3 {
          font-size: 4.5vw;
        }
        > figure {
          > img {
          }
        }
      }
    }
  }
`;

export const Success = styled.div`
  background-color: pink;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40%;
  margin: auto;
  padding: 10% 0;
  border-radius: 5px;
  background-color: ${whiteSphera};
  > figure {
    width: 150px;
    margin: 0 auto 5% auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  > h2 {
    color: ${brandBlack};
    font-size: 1.5vw;
    width: 100%;
    text-align: center;
    margin: 5% 0;
  }
`;

export const RegisterCLABEForm = styled.div`
  width: 90%;
  margin: 2.5% auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  > p {
    font-size: 1.2vw;
    font-weight: bold;
    color: ${greenSp};
    margin-bottom: 5%;
  }
  > input {
    font-size: 1.2vw;
    color: ${grayPlaceholder};
    width: 80%;
    height: 35px;
    margin-bottom: 2.5%;
    padding-left: 2.5%;
    border: 1px solid ${grayLightSphera};
    border-radius: 5px;
  }
  > select {
    font-size: 1.2vw;
    color: ${grayPlaceholder};
    width: 80%;
    height: 35px;
    margin-bottom: 2.5%;
    padding-left: 2.5%;
    border: 1px solid ${grayLightSphera};
    border-radius: 5px;
  }

  > h3 {
    font-size: 1.2vw;
    color: ${graySphera};
    margin-bottom: 2.5%;
    text-align: center;
  }

  > h2 {
    font-size: 1.4vw;
    color: ${greenSp};
    margin-bottom: 2.5%;
    text-align: center;
    font-weight: bold;
  }

  > div {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 90%;
    > h3 {
      font-size: 1.2vw;
      color: ${graySphera};
      margin-bottom: 2.5%;
    }
    > input {
      font-size: 1.2vw;
      color: ${grayPlaceholder};
      width: 10%;
      height: 30px;
      margin-bottom: 2.5%;
      padding-left: 2.5%;
      border: 1px solid ${grayLightSphera};
      border-radius: 5px;
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
    margin: 5% auto;
    > div:nth-child(1) {
      > h3 {
        font-size: 4.2vw;
        margin-bottom: 5%;
      }
      > input {
        font-size: 4.2vw;
        width: 100%;
        margin-bottom: 5%;
        padding-left: 5%;
      }
      > p {
        font-size: 4.2vw;
      }
    }

    > div:nth-child(2) {
      flex-direction: column;
      width: 100%;
      > button {
        font-size: 4.2vw;
        width: 100%;
        margin-bottom: 5%;
      }
      > a {
        font-size: 4.2vw;
        width: 100%;
      }
    }
  }
`;
